<!--
 * @Description:
 * @Author: -898-
 * @Date: 2025-03-10 10:41:30
 * @LastEditTime: 2026-06-25 14:04:24
 * @LastEditors: zZZz
-->
<template>
  <div class="supplier-login_container">
    <div class="content">
      <div class="close-btn">
        <img src="@/assets/img/close.png" alt="" @click="close" />
      </div>
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
        <div class="title">欢迎登录</div>
        <div class="lginTab">
          <div :class="userType == 3 ? 'active' : ''" @click="chooseUserType(3)">
            供应商
          </div>
          <div :class="userType == 2 ? 'active' : ''" @click="chooseUserType(2)">
            采购方
          </div>
          <!-- <div :class="userType == 5 ? 'active' : ''" @click="chooseUserType(5)">
            代理机构
          </div> -->
          <div :class="userType == 4 ? 'active' : ''" @click="chooseUserType(4)">
            专家
          </div>
        </div>
        <div class="loginType">
          <div :class="loginType === 1 ? 'active' : ''" @click="typeClick(1)">
            密码登录
          </div>
          <div :class="loginType === 2 ? 'active' : ''" @click="typeClick(2)">
            短信登录
          </div>
        </div>
        <el-form-item prop="phone" v-if="loginType === 2">
          <el-input placeholder="请输入手机号" :maxlength="11" v-model="loginForm.phone">
            <template slot="prepend">+86</template>
          </el-input>
          <!--        <el-input v-model="loginForm.account" type="text" auto-complete="off" placeholder="手机号">-->
          <!--          <i slot="prefix" class="el-input__icon input-icon el-icon-user" />-->
          <!--        </el-input>-->
        </el-form-item>
        <el-form-item prop="yzm" v-if="loginType === 2">
          <el-input style="width: calc(100% - 120px)" placeholder="请输入验证码" v-model="loginForm.yzm"></el-input>
          <el-button class="yzmButton" v-if="timeYzm === 0" type="primary" @click="getPhoneCode">获取验证码</el-button>
          <el-button class="yzmButton" v-else type="primary">{{ timeYzm }}s</el-button>
        </el-form-item>
        <el-form-item prop="account" v-if="loginType === 1">
          <el-input v-model="loginForm.account" type="text" :clearable="false" auto-complete="off" placeholder="请输入账号">
            <i slot="prefix" class="el-input__icon input-icon el-icon-user-solid" />
          </el-input>
        </el-form-item>
        <el-form-item prop="password" v-if="loginType === 1">
          <el-input v-model="loginForm.password" type="password" :show-password="true" :clearable="false"
            auto-complete="off" placeholder="请输入密码" @keyup.enter.native="handleLogin">
            <i slot="prefix" class="el-input__icon input-icon el-icon-lock" />
          </el-input>
        </el-form-item>
        <el-form-item prop="code" v-if="captchaEnabled && loginType === 1">
          <el-input v-model="loginForm.code" auto-complete="off" placeholder="验证码" style="width: calc(100% - 110px)"
            @keyup.enter.native="handleLogin">
            <!-- <i slot="prefix" class="el-input__icon input-icon el-icon-s-check" /> -->
            <img slot="prefix" src="@/assets/img/common/validCode.svg" alt="" class="el-input__icon input-icon" />
          </el-input>
          <div class="login-code">
            <img :src="codeUrl" @click="getCode" class="login-code-img" />
          </div>
        </el-form-item>
        <div class="remember">
          <el-checkbox v-model="loginForm.read" class="readText">
            我已阅读并同意 <span class="text" @click="textRead">《用户隐私协议》</span>
          </el-checkbox>

          <!-- <el-checkbox v-model="loginForm.read" class="readText">
            我已阅读并同意<span class="text" @click="textRead">{{
              userType === 4 ? "《评标专家承诺书》" : "《用户使用协议》"
            }}</span
            >及<span class="text">《隐私协议》</span>
          </el-checkbox> -->
        </div>
        <el-form-item style="width: 100%">
          <el-button :loading="loading" size="medium" type="primary" style="width: 100%"
            @click.native.prevent="handleLogin">
            <span v-if="!loading">登 录</span>
            <span v-else>登 录 中...</span>
          </el-button>
        </el-form-item>
        <div class="remember">
          <!--<el-checkbox v-model="loginForm.rememberMe" style="margin: 0px 0px 25px 0px"-->
          <!--&gt;记住密码</el-checkbox-->
          <!--&gt;-->
          <span class="forget" @click="forgetFunc">忘记密码？</span>
        </div>
        <div class="registerView">
          <span>没有账号？</span>
          <span class="now" @click="registerNow">立即注册</span>
          <!-- <router-link class="now" :to="'/register'" @click="registerNow"
            ></router-link
          > -->
        </div>
      </el-form>
    </div>
    <tian-ai-captcha v-if="showCaptcha" @success="onCaptchaSuccess" @close="onCaptchaClose" />
    <forget ref="forget" />
    <userText :dialogVisible="dialogVisible" @refuse="refuse" @agree="agree" />
  </div>
</template>
<script>
import {
  getCodeImg,
  getPhoneCode as requestPhoneCode,
  isAuth,
  getInfo,
  isAuthPur,
  isAuthExpert,
} from "@/api/supplierLogin";
import { setAuth, setUsername } from "@/utils/auth";
import Cookies from "js-cookie";
import { encrypt, decrypt, aesEncrypt } from "@/utils/jsencrypt";
import forget from "@/components/forget";
import userText from "@/components/userText";
import TianAiCaptcha from "@/components/TianAiCaptcha";
export default {
  name: "SupplierLogin",
  components: {
    forget,
    userText,
    TianAiCaptcha,
  },
  props: {
    isSignUp: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      }
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    return {
      userType: 3,
      timeYzm: 0,
      loginType: 1,
      activeTab: 0,
      codeUrl: "",
      loginForm: {
        account: "",
        password: "",
        phone: "",
        yzm: "",
        // rememberMe: false,
        read: false,
        code: "",
        uuid: "",
      },
      loginRules: {
        phone: [{ required: true, validator: checkPhone }],
        yzm: [{ required: true, message: "请输入验证码" }],
        account: [{ required: true, trigger: "blur", message: "请输入账号" }],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }],
      },
      loading: false,
      // 验证码开关
      captchaEnabled: true,
      showCaptcha: false,
      slideCaptchaData: null,
      timeInte: null,
      // 注册开关
      register: false,
      redirect: undefined,
      dialogVisible: false,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    this.getCode();
    // this.getCookie();
  },
  methods: {
    textRead() {
      this.dialogVisible = true;
    },
    agree() {
      this.dialogVisible = false;
      this.loginForm.read = true;
    },
    refuse() {
      this.dialogVisible = false;
      this.loginForm.read = false;
    },
    getPhoneCode() {
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.loginForm.phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      this.showCaptcha = true;
    },
    onCaptchaSuccess(data) {
      this.showCaptcha = false;
      this.slideCaptchaData = data;
      this.sendPhoneCode();
    },
    onCaptchaClose() {
      this.showCaptcha = false;
    },
    sendPhoneCode() {
      if (!this.slideCaptchaData || !this.slideCaptchaData.uuid || !this.slideCaptchaData.code) {
        this.$message.error("滑块验证结果异常，请重试");
        return;
      }
      requestPhoneCode({
        account: this.loginForm.phone,
        uuid: this.slideCaptchaData.uuid,
        code: this.slideCaptchaData.code,
      })
        .then(() => {
          this.timeYzm = 60;
          this.timeInte = setInterval(() => {
            this.timeYzm -= 1;
            if (this.timeYzm === 0) {
              clearInterval(this.timeInte);
              this.timeInte = null;
            }
          }, 1000);
        })
        .catch(() => {
          this.$message.error("验证码发送失败，请重试");
        })
        .finally(() => {
          this.slideCaptchaData = null;
        });
    },
    chooseUserType(val) {
      if (!this.isSignUp) {
        this.userType = val;
      } else {
        this.userType = 3;
        this.$message.error("只有供应商能进行投标申请");
      }
    },
    tabClick(tab) {
      this.activeTab = tab;
    },
    typeClick(type) {
      this.loginType = type;
      this.$nextTick(() => {
        this.$refs.loginForm.clearValidate();
      });
    },
    forgetFunc() {
      this.$refs.forget.open(this.userType);
    },
    getCode() {
      getCodeImg().then((res) => {
        this.captchaEnabled =
          res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.loginForm.uuid = res.uuid;
        }
      });
    },
    getCookie() {
      // const account = Cookies.get("account");
      // const password = Cookies.get("password");
      // const rememberMe = Cookies.get("rememberMe");
      // this.loginForm = {
      //   account: account === undefined ? this.loginForm.account : account,
      //   password: password === undefined ? this.loginForm.password : decrypt(password),
      // rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
      // };
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          if (!this.loginForm.read) {
            this.$message.error("请阅读并同意《用户使用协议》及《隐私协议》");
            return;
          }
          this.loading = true;
          // if (this.loginForm.rememberMe) {
          //   Cookies.set("account", this.loginForm.account, { expires: 30 });
          //   Cookies.set("password", encrypt(this.loginForm.password), { expires: 30 });
          //   Cookies.set("rememberMe", this.loginForm.rememberMe, { expires: 30 });
          // } else {
          //   Cookies.remove("account");
          //   Cookies.remove("password");
          //   Cookies.remove("rememberMe");
          // }
          this.loginForm.loginType = this.loginType;
          let formLogin = {};
          // 密码登录
          if (this.loginType === 1) {
            formLogin = {
              account: this.loginForm.account,
              password: aesEncrypt(this.loginForm.password),
              userType: this.userType,
              loginType: this.loginType,
              code: this.loginForm.code,
              uuid: this.loginForm.uuid,
            };
          }
          // 短信登录
          if (this.loginType === 2) {
            formLogin = {
              account: this.loginForm.phone,
              userType: this.userType,
              loginType: this.loginType,
              code: this.loginForm.yzm,
              uuid: this.loginForm.uuid,
            };
          }
          this.$store
            .dispatch("Login", formLogin)
            .then(() => {
              // this.$router.push({ path: this.redirect || "/" }).catch(() => { });
              // 供应商是否认证
              var loginFunc = null;
              if (this.userType === 3) {
                loginFunc = isAuth;
              }
              if (this.userType === 2) {
                loginFunc = isAuthPur;
              }
              if (this.userType === 4) {
                loginFunc = isAuthExpert;
              }
              // setToken(data.access_token);
              loginFunc()
                .then((res) => {
                  setAuth(res.data ? 1 : 0);
                  getInfo().then((resp) => {
                    console.log(resp, "res");

                    setUsername(resp.user.nickName);
                    this.$emit("closeDialog");
                    window.location.reload();
                  });
                })
                .error((err) => {
                  this.loading = false;
                });
            })
            .catch(() => {
              this.loading = false;
              if (this.captchaEnabled) {
                this.getCode();
              }
            });
        }
      });
    },
    close() {
      this.$emit("closeDialog");
    },
    // 跳转注册
    registerNow() {
      window.open(process.env.VUE_APP_BASE + "/register", "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.supplier-login_container {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  background: rgba(0, 0, 0, 0.5);

  .content {
    width: 480px;
    height: 540px;
    background: #ffffff;
    border-radius: 16px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 40px 50px;

    .close-btn {
      position: absolute;
      right: -80px;
      top: -50px;

      img {
        width: 35px;
        cursor: pointer;
      }
    }

    .title {
      font-weight: 600;
      font-size: 36px;
      color: #333333;
      line-height: 50px;
      margin-bottom: 30px;
    }

    .loginType {
      display: flex;
      justify-content: center;

      div {
        margin: 0 10px 40px 10px;
        cursor: pointer;
        height: 50px;
        width: 200px;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        line-height: 55px;
      }

      .active {
        color: #3177ff;
        border-bottom: 2px solid #3177ff;
      }
    }

    .remember {
      display: flex;
      justify-content: space-between;

      //align-items: center;
      //margin-bottom: 25px;
      .forget {
        color: #1890ff;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .readText {
      margin-bottom: 20px;

      .text {
        color: #1890ff;
        cursor: pointer;
      }
    }

    .registerView {
      border-top: 1px solid #e8e8e8;
      text-align: center;
      padding-top: 10px;
      font-size: 14px;

      .now {
        color: #1890ff;
        cursor: pointer;
      }
    }

    .yzmButton {
      // margin-left: 10px;
      width: 110px;
      height: 35px;
      position: absolute;
      right: 0;
      top: 3px;
    }

    .lginTab {
      height: 50px;
      line-height: 50px;
      margin-bottom: 10px;
      display: flex;
      //background: #98A4AF;
      box-shadow: inset 0px -1px 10px 0px rgba(152, 164, 175, 0.18);
      border-radius: 5px;

      div {
        width: 33.33%;
        text-align: center;
        cursor: pointer;
        border-radius: 5px;
        font-size: 14px;
      }

      .active {
        background: rgba(49, 119, 255, 0.1);
        color: #3177ff;
      }

      .activeNo {}
    }

    .login-form {
      // position: absolute;
      // right: 240px;
      // top: 50%;
      // transform: translateY(-55%);

      // border-radius: 6px;
      // //background: #ffffff;
      // width: 518px;
      // padding: 52px 58px 50px 58px;
      //padding: 25px 25px 5px 25px;
      // background-image: url("../assets/images/login_form-bg.png");
      background-size: 100% 100%;

      .el-input {
        height: 38px;

        input {
          height: 38px;
        }
      }

      .input-icon {
        height: 39px;
        width: 14px;
        margin-left: 2px;
      }
    }

    .login-code {
      width: 100px;
      height: 38px;
      float: right;

      img {
        cursor: pointer;
        vertical-align: middle;
        height: 38px;
      }
    }
  }
}
</style>
